import { render, staticRenderFns } from "./el-loader.vue?vue&type=template&id=1b886e06&scoped=true&"
import script from "./el-loader.vue?vue&type=script&lang=js&"
export * from "./el-loader.vue?vue&type=script&lang=js&"
import style0 from "./el-loader.vue?vue&type=style&index=0&id=1b886e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b886e06",
  null
  
)

export default component.exports